// extracted by mini-css-extract-plugin
module.exports = {"bulletItem":"BulletBoxItem_bulletItem__0U4Fi","titleWrapper":"BulletBoxItem_titleWrapper__dTe_1","arrowBtn":"BulletBoxItem_arrowBtn__RZZxA"};